const fileTypes = {
  HARTCHART_FOLDERS_OPEN_MODAL: 'HARTCHART_FOLDERS_OPEN_MODAL',
  HARTCHART_FOLDERS_CLOSE_MODAL: 'HARTCHART_FOLDERS_CLOSE_MODAL'
}

export default fileTypes
